<script>
import axios from 'axios';
import AS from '@/services/AuthenticationService';

export default {
  adminFetchInfraction({ status = '', page }) {
    const params = { status, page };
    return axios.get('admin/requerimentos/autos', { params, ...AS.getDefaultHeaders() });
  },
};

</script>